export const links = {
  pokerHistoryLink: "/app/poker-history/"
};

export const config = { logo: "sport_logo", logoMobile: "sport_logo_mobile" };
